<app-widget-card-wrapper title="Wai – Monitoring Station">
  <div class="card-stretch text-center">
    <img src="assets/dissolved-oxygen-graph.jpg" class="img-fluid" />
  </div>
</app-widget-card-wrapper>
